import { define } from '../redux-request';
import api from '../../api/api';

export const GET_PATIENTS = define('GET_PATIENTS');

export function getPatientsRequest(data) {
  return GET_PATIENTS.request(() => api.getPatients(data));
}

export const GET_ONE_PATIENT = define('GET_ONE_PATIENT');

export function getOnePatient(data) {
  return GET_ONE_PATIENT.request(() => api.getPatients(data));
}

export const UPDATE_PATIENT = define('UPDATE_PATIENT');

export function updatePatientRequest(data) {
  return UPDATE_PATIENT.request(() => api.updatePatient(data))
    .onSuccess(() => data);
}

export const GET_PAST_INSURANCE = define('GET_PAST_INSURANCE');

export function getPastInsuranceRequest(data) {
  return GET_PAST_INSURANCE.request(() => api.getPastInsurance(data));
}

export const GET_PATIENT_ATTACHMENTS = define('GET_PATIENT_ATTACHMENTS');

export function getPatientAttachmentsRequest(data) {
  return GET_PATIENT_ATTACHMENTS.request(() => api.getPatientAttachments(data));
}

export const SEND_INSURANCE_FILE = define('SEND_INSURANCE_FILE');

export function sendInsuranceFileRequest(data) {
  return SEND_INSURANCE_FILE.request(() => api.sendInsuranceFile(data));
}

export const UPLOAD_INSURANCE_FILE = define('UPLOAD_INSURANCE_FILE');

export function uploadInsuranceFileRequest(data) {
  return UPLOAD_INSURANCE_FILE.request(() => api.uploadInsuranceFile(data));
}

export const ADD_PATIENT_NODE = define('ADD_PATIENT_NODE');

export function addPatientNodeRequest(data) {
  return ADD_PATIENT_NODE.request(() => api.addPatientNode(data));
}

export const GET_PATIENTS_NODE = define('GET_PATIENTS_NODE');

export function getPatientsNodeRequest(data) {
  return GET_PATIENTS_NODE.request(() => api.getPatientsNode(data));
}
